module.exports = __webpack_public_path__ + "static/img/SourceSansPro-Italic.16f3f5d.svg";